var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-36.2475 -22.75 314.145 136.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005AF0",
    d: "M147.69 59.034h-14.31L131.004 66h-9.72l13.986-37.908h10.638L159.894 66h-9.828zm-2.376-7.02l-4.752-14.04-4.806 14.04zm61.074-23.922V66h-9.234V42.294L188.946 66h-7.992l-8.262-23.76V66h-9.234V28.092h11.286l10.314 26.406 10.098-26.406zm15.606 24.516V66h-9.234V27.822h14.958c4.536 0 7.992 1.125 10.368 3.375 2.376 2.25 3.564 5.283 3.564 9.099 0 2.376-.531 4.491-1.593 6.345-1.062 1.854-2.637 3.312-4.725 4.374-2.088 1.062-4.626 1.593-7.614 1.593zm4.698-7.398c3.708 0 5.562-1.638 5.562-4.914 0-3.348-1.854-5.022-5.562-5.022h-4.698v9.936z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 45.5C0 70.6281 20.3719 91 45.5 91 70.6312 91 91 70.6281 91 45.5S70.6312 0 45.5 0C20.3719 0 0 20.3719 0 45.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005AF0",
    d: "M42.0117 73.0973h-3.458l3.4216-20.6965-10.5864.0152h-.1516c-.9514-.0033-1.7213-.7746-1.723-1.726 0-.4095.3792-1.101.3792-1.101l19.025-31.7287 3.5187.0151-3.5065 20.7298 10.641-.012h.1698c.9525 0 1.726.7704 1.726 1.7228 0 .3883-.1517.728-.367 1.0162zM45.5 0C20.3719 0 0 20.3719 0 45.5S20.3719 91 45.5 91C70.6312 91 91 70.6281 91 45.5S70.6312 0 45.5 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmp);
export default __webpack_public_path__ + "static/media/amp.f1c8b032a49a5283cfd900ad4d0299f8.svg";
export { ForwardRef as ReactComponent };